/* eslint-disable no-extra-parens */
//TODO: Add functionality to allow for changing a on a cookie by passing two keys (cookie key and object key) and a value

export function getDomainForCookies() {
    const hostname = window.location.hostname;

    if (hostname.includes('weatherbug.com')) {
        return '.weatherbug.com';
    }

    if (hostname.includes('weatherbugsc.com')) {
        return '.weatherbugsc.com';
    }

    // local host:
    if (hostname === 'localhost') {
        return null;
    }

    return null; // default case - we let the browser handle this - really shouldn't to avoid cookie mismatch with web 2
}

export function getCookieByKey(key)
{
    let cookieValue = null;

    const cookies = document.cookie.split(';');
    if (cookies && cookies.length > 0)
    {
        const cookie = cookies.find(x => x.trim().startsWith(key + '='));
        if (cookie)
        {
            cookieValue = window.decodeURIComponent(cookie.split('=')[1]);
        }
    }

    return cookieValue;
}

export function getJsonCookieByKey(key)
{
    let cookieValue = null;

    const cookie = getCookieByKey(key);

    if (cookie)
    {
        cookieValue = JSON.parse(cookie.replace(/%2C/g, ','));
    }

    return cookieValue;
}

export function setCookie(key, value, days)
{
    if (getCookieByKey(key))
    {
        deleteCookie(key);
    }

    let expires = '';
    if (days)
    {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }

    const cookieDomain = getDomainForCookies();

    let cookieString = `${key}=${window.encodeURIComponent(value)}${expires};Path=/;`;

    if (cookieDomain) {
        cookieString += ` domain=${cookieDomain};`;
    }
    
    document.cookie = cookieString;
}

export function setJsonCookie(key, object, days)
{
    if (getCookieByKey(key))
    {
        deleteCookie(key);
    }

    let expires = '';
    if (days)
    {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }

    const cookieDomain = getDomainForCookies();

    let cookieString = `${key}=${window.encodeURIComponent(JSON.stringify(object))}${expires};Path=/;`;

    if (cookieDomain) {
        cookieString += ` domain=${cookieDomain};`;
    }
    
    document.cookie = cookieString;
    
}

export function deleteCookie( name ) {
    document.cookie = name + '= ; expires = Thu, 01 Jan 1970 00:00:01 GMT;Path=/;';
}
